import InfoPageLayout, { InfoSection } from "@/components/InfoPageLayout";

export default function Terms() {
  return (
    <InfoPageLayout
      eyebrow="Terms of Service"
      title="The agreement between you and GuardianNest."
      intro="Plain-language terms that describe what GuardianNest provides, what we ask of you, and what to expect if something goes wrong."
      updated="July 2026"
    >
      <InfoSection title="Using GuardianNest">
        <p>
          You may create an account and use GuardianNest to organize health information for
          yourself and the people you care for. You're responsible for keeping your login
          credentials secure and for the accuracy of the information you enter.
        </p>
      </InfoSection>

      <InfoSection title="Not medical advice">
        <p>
          GuardianNest is a caregiving and record-keeping tool. It does not diagnose conditions,
          prescribe treatment, or replace a licensed healthcare provider. Features like symptom
          notes, dosing helpers, and doctor reports are informational aids — always consult a
          qualified clinician for medical decisions, and call emergency services in a
          life-threatening situation.
        </p>
      </InfoSection>

      <InfoSection title="Your content">
        <p>
          You own the content you add to GuardianNest. By using the service you grant us a limited
          license to store, display, and process that content solely to operate the features you
          use. Sharing content with caregivers you invite is your choice and your responsibility.
        </p>
      </InfoSection>

      <InfoSection title="Acceptable use">
        <p>
          Don't use GuardianNest to store information you're not authorized to hold, to harass
          others, to attempt to break the security of the service, or to violate the law. We may
          suspend accounts that do.
        </p>
      </InfoSection>

      <InfoSection title="Payments and cancellations">
        <p>
          Paid plans are billed monthly or annually as selected at checkout. You can cancel from
          your account at any time; cancellation stops future charges and downgrades you to the
          free tier at the end of the current billing period. Your data remains available on the
          free tier.
        </p>
      </InfoSection>

      <InfoSection title="Service availability">
        <p>
          We work hard to keep GuardianNest available and accurate, but the service is provided
          "as is" without warranties. Our liability is limited to the amount you paid us in the
          twelve months before a claim arose. Nothing in these terms limits liability that cannot
          be limited under applicable law.
        </p>
      </InfoSection>

      <InfoSection title="Changes">
        <p>
          We may update these terms as the product evolves. Meaningful changes will be announced
          in the app and by email at least 30 days before they take effect.
        </p>
      </InfoSection>

      <InfoSection title="Contact">
        <p>
          Questions about these terms? Reach us at{" "}
          <a
            href="mailto:legal@guardiannest.net"
            className="font-semibold text-primary hover:underline"
          >
            legal@guardiannest.net
          </a>
          .
        </p>
      </InfoSection>
    </InfoPageLayout>
  );
}
